import axios from 'axios'
import { appConfig } from 'configs';
import {
  getPath,
  getCustomUrl,
  createUrlParamFromObj,
  getContentType,
  createHeader
} from 'helpers';

export const cancelTokenSource = axios.CancelToken.source;

export const apiInstance = axios.create({
  baseURL: appConfig.url.api,
  timeout: 60000,
  cancelToken: cancelTokenSource.token,
  validateStatus: status => status >= 200 && status < 300
});

class ApiRequest {
  static request = async (method = 'GET', route = '', payload = {}) => {
    const path = getPath(payload.path);
    const cancelToken = payload.cancelToken
    const params = createUrlParamFromObj(payload.params);
    const customUrl = getCustomUrl(payload.url);
    const contentType = getContentType(payload.type);
    const baseHeaders = { 'Content-Type': contentType };
    const headers = createHeader(payload.headers, baseHeaders);
    const url = customUrl.length > 0 ? customUrl : route + path + params;
    const data = payload.body ? payload.body : {};
    const requestObj = { url, headers, method, data, cancelToken };

    try {
      const response = await apiInstance.request(requestObj);
      const responseData = response.data;
      if (responseData) {
        return { axiosResponse: response, ...responseData };
      }
      return { axiosResponse: response, ...response };
    } catch (err) {
      if (err && err.response && err.response.data) {
        throw err.response.data;
      } else if (err && err.response) {
        throw err.response;
      } else {
        throw err;
      }
    }
  };

  static get = route => payload => this.request('GET', route, payload);

  static put = route => payload => this.request('PUT', route, payload);

  static post = route => payload => this.request('POST', route, payload);

  static delete = route => payload => this.request('DELETE', route, payload);

  static patch = route => payload => this.request('PATCH', route, payload);
}

export default ApiRequest;